import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoaderService } from "../service/loader.service";
import { RestService } from "../service/rest.service";
import { Message } from "../service/message.service";

@Component({
  selector: "app-pages",
  template: `
  <div id="container-manager"  class=" !w-screen overflow-hidden flex bg-[#F1F5FF] !h-[100dvh]" [ngClass]="{'hidden': !logged}">
 @if(showSideNav){<div (click)="window.innerWidth < 768 ? showSideNav = false : null" class="fixed left-0 top-0 md:relative w-fit h-[100dvh] bg-quaternary z-10 overflow-x-hidden overflow-y-scroll custom-scrollbar"><div style="align-content: start;" class="w-[90px] bg-quaternary flex items-start flex-wrap place-content-center select-none h-[100svh]">
      <div class="w-[90px] h-[var(--hMaxResize)] overflow-y-scroll custom-scrollbar ">
        <img (click)="goBackToWeb()" class="mb-[47px] cursor-pointer size-[50px] mx-auto mt-[21px]" src="../../assets/logo.svg">
        <div class="">
  <div class="cursor-pointer mb-[28px]" (click)="goBackToWeb()">
          <svg class="mx-auto" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path [ngClass]="{'!fill-Swhite': window.location.pathname === '/oaiddasodjoida'}" d="M13.2831 5.14247C13.2075 5.07015 13.1069 5.02979 13.0023 5.02979C12.8977 5.02979 12.7971 5.07015 12.7215 5.14247L3.37264 14.0734C3.33294 14.1113 3.30135 14.157 3.27979 14.2075C3.25823 14.2581 3.24715 14.3124 3.24721 14.3674L3.24569 22.7493C3.24569 23.1803 3.41689 23.5936 3.72164 23.8984C4.02638 24.2031 4.43971 24.3743 4.87069 24.3743H9.75076C9.96625 24.3743 10.1729 24.2887 10.3253 24.1364C10.4777 23.984 10.5633 23.7773 10.5633 23.5618V16.6556C10.5633 16.5479 10.6061 16.4445 10.6823 16.3683C10.7584 16.2921 10.8618 16.2493 10.9695 16.2493H15.032C15.1398 16.2493 15.2431 16.2921 15.3193 16.3683C15.3955 16.4445 15.4383 16.5479 15.4383 16.6556V23.5618C15.4383 23.7773 15.5239 23.984 15.6762 24.1364C15.8286 24.2887 16.0353 24.3743 16.2508 24.3743H21.1288C21.5598 24.3743 21.9731 24.2031 22.2779 23.8984C22.5826 23.5936 22.7538 23.1803 22.7538 22.7493V14.3674C22.7539 14.3124 22.7428 14.2581 22.7212 14.2075C22.6997 14.157 22.6681 14.1113 22.6284 14.0734L13.2831 5.14247Z" fill="#719CFF"/>
<path [ngClass]="{'!fill-Swhite': window.location.pathname === '/oaiddasodjoida'}" d="M24.9288 12.3982L21.1304 8.76434V3.25C21.1304 3.03451 21.0448 2.82785 20.8924 2.67548C20.74 2.5231 20.5334 2.4375 20.3179 2.4375H17.8804C17.6649 2.4375 17.4582 2.5231 17.3058 2.67548C17.1535 2.82785 17.0679 3.03451 17.0679 3.25V4.875L14.1266 2.06273C13.8514 1.78445 13.4421 1.625 12.9998 1.625C12.559 1.625 12.1507 1.78445 11.8755 2.06324L1.0743 12.3972C0.758443 12.7019 0.718834 13.2031 1.00626 13.5332C1.07843 13.6165 1.16681 13.6843 1.266 13.7324C1.3652 13.7804 1.47314 13.8078 1.58325 13.8129C1.69337 13.8179 1.80336 13.8005 1.90653 13.7616C2.0097 13.7228 2.10389 13.6634 2.18337 13.587L12.7205 3.51813C12.7961 3.4458 12.8967 3.40544 13.0013 3.40544C13.1059 3.40544 13.2065 3.4458 13.2821 3.51813L23.8202 13.587C23.9755 13.7359 24.1834 13.8171 24.3984 13.813C24.6135 13.8088 24.8181 13.7195 24.9674 13.5647C25.2792 13.2417 25.2533 12.7085 24.9288 12.3982Z" fill="#719CFF"/>
</svg>
<div class="text-center text-primary text-font14px font-medium mt-[6px]" [ngClass]="{'!text-Swhite': window.location.pathname === '/oaiddasodjoida'}">Home</div>
        </div>
      @for (route of routes; track $index) {
      <div class="mb-[28px] cursor-pointer" (click)="currentRoute = route.route;goto(route.route)" [ngClass]="{'opacity-60': !route.activate.includes(window.location.pathname.split('/')[1])}">
      <img class="size-[26px] mx-auto" [src]="route.activate.includes(window.location.pathname.split('/')[1]) ? route.focusIcon : route.icon">

<div class="text-center text-primary text-font14px font-medium mt-[6px]" [ngClass]="{'!text-Swhite': route.activate.includes(window.location.pathname.split('/')[1])}">{{route.title}}</div>
        </div>

      }
</div>
<div class="underline text-font14px text-Swhite text-center cursor-pointer" (click)="logout()">Logout</div>
</div>

    </div>
  </div>}

@if(!showSideNav){
  <div class="md:hidden fixed top-5 right-5 size-10 rounded-full bg-quaternary flex items-center place-content-center" (click)="showSideNav = true">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3.00098 18.0002H21.001V16.0001H3.00098V18.0002ZM3.00098 13.0001H21.001V11.0004H3.00098V13.0001ZM3.00098 6.00024V8.00039H21.001V6.00024H3.00098Z"
                            fill="white" />
                    </svg>
  </div>
}

    <div class="w-screen md:w-[calc(100vw-90px)]">
    <div>
    <app-header [title]="window.location.pathname.split('/')[1]" [routes]="[{label:window.location.pathname.split('/')[1],route:'/' + window.location.pathname.split('/')[1]}]"></app-header>
    </div>
     <div class="w-full h-[calc(100dvh-90px)] overflow-y-scroll custom-scrollbar">

    <router-outlet></router-outlet></div>
    </div>
</div>`,
  styles: [],
  standalone: false,
})
export class ContainerComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message:Message
  ) { }
  logged = false
  window = window
  showSideNav = window.innerWidth >= 768
  currentRoute = ''
  routes: any[] = []

  ngOnInit(): void {
    this.loader.on()
    this.rest.get('/user/me').subscribe({
      next: (value: any) => {
        this.loader.off(true)
        if (!value.completed) {
          this.router.navigate(['completa-profilo'])
        }
        this.logged = true
        if (value.role == 1) {
          this.routes = [{
            route: '/cerca-bando',
            title: 'Bandi',
            activate: ['bandi', 'dettaglio-bando'],
            icon: '../../assets/bandi.svg',
            focusIcon: '../../assets/bandiFocus.svg'
          }, {
            route: '/catalogo',
            title: 'Catalogo',
            activate: ['catalogo'],
            icon: '../../assets/bandi.svg',
            focusIcon: '../../assets/bandiFocus.svg'
          }, {
            route: '/progetti',
            title: 'Progetti',
            activate: ['progetti', 'progetto'],
            icon: '../../assets/progetti.svg',
            focusIcon: '../../assets/progettiFocus.svg'
          }, {
            route: '/giorni',
            title: 'Giorni',
            activate: ['giorni'],
            icon: '../../assets/profilo.svg',
            focusIcon: '../../assets/profiloFocus.svg'
          }, {
            route: '/date',
            title: 'Date',
            activate: ['date'],
            icon: '../../assets/profilo.svg',
            focusIcon: '../../assets/profiloFocus.svg'
          },]
        }
        if (value.role == 2 || value.role == 3 || value.role == 4) {
          this.routes = [{
            route: '/cerca-bando',
            title: 'Bandi',
            activate: ['bandi', 'dettaglio-bando'],
            icon: '../../assets/bandi.svg',
            focusIcon: '../../assets/bandiFocus.svg'
          }, {
            route: '/catalogo',
            title: 'Catalogo',
            activate: ['catalogo'],
            icon: '../../assets/bandi.svg',
            focusIcon: '../../assets/bandiFocus.svg'
          }, {
            route: '/progetti',
            title: 'Progetti',
            activate: ['progetti', 'progetto'],
            icon: '../../assets/progetti.svg',
            focusIcon: '../../assets/progettiFocus.svg'
          }]
        }

        if (value.role == 5) {
          this.routes = [
            {
              route: '/bandi-admin',
              title: 'Bandi',
              activate: ['bandi-admin', 'dettaglio-bando'],
              icon: '../../assets/bandi.svg',
              focusIcon: '../../assets/bandiFocus.svg'
            },
            {
              route: '/appuntamenti',
              title: 'Call',
              activate: ['appuntamenti'],
              icon: '../../assets/bandi.svg',
              focusIcon: '../../assets/bandiFocus.svg'
            }, {
              route: '/catalogo',
              title: 'Catalogo',
              activate: ['catalogo'],
              icon: '../../assets/bandi.svg',
              focusIcon: '../../assets/bandiFocus.svg'
            }, {
              route: '/categorie',
              title: 'Categorie',
              activate: ['categorie'],
              icon: '../../assets/bandi.svg',
              focusIcon: '../../assets/bandiFocus.svg'
            }, {
              route: '/richieste',
              title: 'Richieste',
              activate: ['richieste'],
              icon: '../../assets/bandi.svg',
              focusIcon: '../../assets/bandiFocus.svg'
            }, 
            // {
            //   route: '/partners',
            //   title: 'Partner',
            //   activate: ['partners'],
            //   icon: '../../assets/bandi.svg',
            //   focusIcon: '../../assets/bandiFocus.svg'
            // },
             {
              route: '/partners-to-approve',
              title: 'Partner da approvare',
              activate: ['partners-to-approve'],
              icon: '../../assets/bandi.svg',
              focusIcon: '../../assets/bandiFocus.svg'
            },
            
            {
              route: '/documenti',
              title: 'Documenti',
              activate: ['documenti'],
              icon: '../../assets/bandi.svg',
              focusIcon: '../../assets/bandiFocus.svg'
            },
            {
              route: '/pagamenti',
              title: 'Pagamenti',
              activate: ['pagamenti'],
              icon: '../../assets/bandi.svg',
              focusIcon: '../../assets/bandiFocus.svg'
            },
            // {
            //   route: '/permessi',
            //   title: 'Permessi',
            //   activate: ['permessi'],
            //   icon: '../../assets/bandi.svg',
            //   focusIcon: '../../assets/bandiFocus.svg'
            // },
            // {
            //   route: '/ruoli',
            //   title: 'Ruoli',
            //   activate: ['ruoli'],
            //   icon: '../../assets/bandi.svg',
            //   focusIcon: '../../assets/bandiFocus.svg'
            // },
            {
              route: '/progetti-admin',
              title: 'Progetti',
              activate: ['progetti-admin', 'progetto'],
              icon: '../../assets/progetti.svg',
              focusIcon: '../../assets/progettiFocus.svg'
            },
            {
              route: '/piani-admin',
              title: 'Piani',
              activate: ['piani-admin'],
              icon: '../../assets/profilo.svg',
              focusIcon: '../../assets/profiloFocus.svg'
            },
            {
              route: '/utenti',
              title: 'Utenti',
              activate: ['utenti'],
              icon: '../../assets/profilo.svg',
              focusIcon: '../../assets/profiloFocus.svg'
            },
          ]
        }

        if (value.role == 6) {
          this.routes = [
            //   {
            //   route: '/bandi-admin',
            //   title: 'Bandi',
            //   activate: ['bandi-admin', 'dettaglio-bando'],
            //   icon: '../../assets/bandi.svg',
            //   focusIcon: '../../assets/bandiFocus.svg'
            // },
            {
              route: '/catalogo',
              title: 'Catalogo',
              activate: ['catalogo'],
              icon: '../../assets/bandi.svg',
              focusIcon: '../../assets/bandiFocus.svg'
            },
            // {
            //   route: '/progetti-admin',
            //   title: 'Progetti',
            //   activate: ['progetti-admin', 'progetto'],
            //   icon: '../../assets/progetti.svg',
            //   focusIcon: '../../assets/progettiFocus.svg'
            // },
            {
              route: '/tech/' + value.id + '/products',
              title: 'Aziende',
              activate: ['tech', 'tech/'],
              icon: '../../assets/progetti.svg',
              focusIcon: '../../assets/progettiFocus.svg'
            }]
        }
        if (value.role == 2 || value.role == 3) {
        this.routes.push({
          route: '/preferenze',
          title: 'Preferenze',
          activate: ['preferenze'],
          icon: '../../assets/profilo.svg',
          focusIcon: '../../assets/profiloFocus.svg'
        })}
        if (value.role == 2 || value.role == 3 || value.role == 5 || value.role == 7) {
        this.routes.push({
          route: '/richieste-ammissibilita',
          title: 'Richieste ammissibilita',
          activate: ['richieste-ammissibilita'],
          icon: '../../assets/progetti.svg',
          focusIcon: '../../assets/progettiFocus.svg'
        })}
        // noticeAdmissibilityRequest
        this.routes.push({
          route: '/profilo',
          title: 'Profilo',
          activate: ['profilo'],
          icon: '../../assets/profilo.svg',
          focusIcon: '../../assets/profiloFocus.svg'
        })
        if (value.role == 6) {
          this.loader.on()
          this.rest.get(`/tech/${value.id}/products`).subscribe({
            next: (responseProducts: any) => {
              if(!(responseProducts?.items > 0)){
                this.router.navigate([`/tech/${value.id}/products`])
                this.message.showMessage('Devi creare almeno una azienda','error')
              }
              this.loader.off(true)
            },
            error: (value: any) => {
              this.router.navigate([`/tech/${value.id}/products`])
                this.message.showMessage('Devi creare almeno una azienda','error')
              this.loader.off(true)
            },
          })
        }
      },
      error: () => {
        this.loader.off(true)
        this.router.navigate(['login'])
      }
    })
  }

  logout() {
    localStorage.clear()
    window.location.replace('')

  }

  goBackToWeb() {
    window.location.replace('')
  }

  goto(route: string) {
    this.router.navigate([route])
  }

}
